export default "__VITE_ASSET__gTdQkKsR__"